module.exports = __webpack_public_path__ + "static/media/icon_twitter.89ce23d6.svg";